import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import './CTASection.css';

const CTASection = () => {
  return (
    <section className="cta-section">
      <div className="container">
        <div className="cta-content">
          <h2>Ready to Build Your Next <span className="white-text">Digital Product?</span></h2>
          <p>
            Let's discuss your project and turn your ideas into reality. 
            Let’s create something your users will love.
          </p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-white">
              <MessageSquare size={20} />
              GET STARTED WITH US
            </Link>
            <Link to="/contact" className="btn btn-outline">
              <MessageSquare size={20} />
              CONTACT US
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;